import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  backgroundColor?: string;
}

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipText = styled.span<{ backgroundColor?: string }>`
  visibility: hidden;
  min-width: 350px;
  background-color: ${(props) => props.backgroundColor || 'white'};
  color: black;
  text-align: center;
  border-radius: 10px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  right: 25%;
  transform: translateX(25%);
  opacity: 0;
  transition: opacity 0.3s;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    right: 24%;
    border-width: 5px;
    border-style: solid;
    border-color: ${(props) => props.backgroundColor || 'white'} transparent transparent transparent;
  }

  ${TooltipContainer}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

const Tooltip: React.FC<TooltipProps> = ({ content, children, backgroundColor }) => {
  return (
    <TooltipContainer>
      {children}
      <TooltipText backgroundColor={backgroundColor}>{content}</TooltipText>
    </TooltipContainer>
  );
};

export default Tooltip;
